import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { professionalAction, userActions } from "../../_actions";
import { saveAs } from "file-saver";
import {
  Drawer,
  Form,
  Select,
  Divider,
  PageHeader,
  Descriptions,
  message,
  Spin,
  DatePicker,
  Button,
  Row,
  Col,
} from "antd";
//import { CCTVLocationTable } from "./CCTVLocationTable";
const CCTVLocationTable = React.lazy(() =>
  import("./CCTVLocationTable").then((module) => ({
    default: module.CCTVLocationTable,
  }))
);

let columns = [];
let data = [];

// const baseUrl = 'http://localhost:8080/api';
class CCTVLocation extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    loading: false,
    cctvLocationList: [],
  };

  componentDidMount() {
    const { user } = this.props;
    if (user && user.cityId && user && user.role === "4") {
      this.setState({
        loading: true,
      });
      professionalAction.getCCTVLocations(user && user.cityId).then((res) => {
        res &&
          res.text().then((text) => {
            this.setState({
              cctvLocationList: text && JSON.parse(text),
              loading: false,
            });
          });
      });
    }
  }

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  getFormat(date) {
    return moment(date).format("YYYY-MM-DD");
  }

  render() {
    const { user, loading } = this.props;
    const requiredKeys = [];
    if (this.state.cctvLocationList && this.state.cctvLocationList.length > 0) {
      let columns1 =
        this.state.cctvLocationList &&
        this.state.cctvLocationList.length &&
        this.state.cctvLocationList.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
            SrNo: index + 1,
          };
        });

      let tablelabes = columns1 && Object.keys(columns1[0]);

      let tableColumns = [];
      tablelabes.forEach((item) => {
        if (
          _.filter(requiredKeys, function (o) {
            return o === item;
          }).length
        ) {
          tableColumns.push(item);
        }
      });

      let columnList = tableColumns.map((item) => {
        return {
          title: item,
          dataIndex: item,
          key: item,
        };
      });
      // columns1.reverse();

      data = columns1;
      columns = columnList;
    } else {
      data = [];
    }
    return (
      <>
        <div className="col-md-6 col-md-offset-3">
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              ghost={false}
              onBack={false}
              title="CCTV Locations"
            ></PageHeader>
          </div>

          <Divider />
          {/* <Spin spinning={loading} > */}
          <div>
            <React.Suspense fallback={<div>Loading...</div>}>
              <CCTVLocationTable
                data={data}
                columns={columns}
              ></CCTVLocationTable>
            </React.Suspense>
          </div>
          {/* </Spin> */}
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { newsList, gpsInformationList, loading } = professionals;
  return {
    user,
    users,
    newsList,
    professionals,
    loading,
  };
}

const connectedCCTVLocation = connect(mapStateToProps)(CCTVLocation);
export { connectedCCTVLocation as CCTVLocation };
